import { NgModule } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { PFieldComponent } from './p-field.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipeModule } from '@panaya/ui/pipes';
import { PIconModule } from '@panaya/ui/p-icon';

@NgModule({
    declarations: [PFieldComponent],
    imports: [NgIf, NgClass, MatTooltipModule, PipeModule, PIconModule],
    exports: [PFieldComponent]
})
export class PFieldModule {}
